<div class="ft-form">
    <div class="content">
      <div class="ft-form-row">
        <span class="title">Add source to marriage event</span>
      </div>
      <div class="ft-form-row">
        <div class="ft-form-row col1-v100">
          <div class="ft-form-input">
            <div class="icon-input-container">
              <input class ="icon-input" type="text" [(ngModel)]="searchPhrase" >
              <div class="icon-input-wrap">                      
                  <img src="/assets/images/date-info.png">                      
              </div>                  
            </div>
          </div>
        </div>            
      </div>         
      <app-media-gallery style="height:calc(100% - 100px)" [items]="mediaItems" [searchPhrase]="searchPhrase"  ></app-media-gallery>          
    </div>
    <div class="footer">
      <button class="ft-btn ft-btn-inactive active" (click)="add()">Add</button>
      <button class="ft-btn ft-btn-active-not-selected" (click)="cancel()">Cancel</button>
    </div>
  </div>
  <!-- Test -->